/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-2",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://8zw3cxvm0h.execute-api.eu-west-2.amazonaws.com/stage",
            "region": "eu-west-2"
        }
    ],
    "aws_cognito_identity_pool_id": "eu-west-2:212c532d-0630-4190-b4de-01663bbd9ad7",
    "aws_cognito_region": "eu-west-2",
    "aws_user_pools_id": "eu-west-2_NeojTq9f0",
    "aws_user_pools_web_client_id": "6dn0r6ftb1c5roldl16qo604n1",
    "oauth": {
        "domain": "cyf-stage.auth.eu-west-2.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://dev.app.compareyourfootprint.com/,https://staging2.app.compareyourfootprint.com/,https://staging.app.compareyourfootprint.com/,https://app.compareyourfootprint.com/",
        "redirectSignOut": "https://dev.app.compareyourfootprint.com/,https://staging2.app.compareyourfootprint.com/,https://staging.app.compareyourfootprint.com/,https://app.compareyourfootprint.com/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_AND_IDENTITY_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL",
        "PHONE_NUMBER"
    ],
    "aws_cognito_social_providers": [
        "GOOGLE"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OPTIONAL",
    "aws_cognito_mfa_types": [
        "TOTP"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_cognito_login_mechanisms": [
        "EMAIL",
        "PHONE_NUMBER",
        "GOOGLE"
    ]
};


export default awsmobile;
